var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-button-container"},[_c('button',{staticClass:"draggable-item-menu-btn draggable-item-menu-btn-blue draggable-item-menu-btn-view",on:{"click":_vm.view}},[_vm._v("\n        Ver\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }